// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1v-q";
export var animationRelative = "_1v-p";
export var backdropBlur = "_1v-0";
export var detailLabelCell = "_1v-12";
export var detailTable = "_1v-11";
export var detailValueCell = "_1v-13";
export var docIconBox = "_1v-1d";
export var docIconBoxMd = "_1v-1f";
export var docIconBoxSm = "_1v-1e";
export var docTypeRow = "_1v-16";
export var docTypeRowInner = "_1v-17";
export var dropdownMatchDatePicker = "_1v-3";
export var evidenceCardContent = "_1v-1c";
export var fileUploadSpin = "_1v-j";
export var gorgiasOpenButton = "_1v-15 _1v-d";
export var gorgiasTicketCard = "_1v-14";
export var heroModalFooterButton = "_1v-18";
export var hiddenContainer = "_1v-o";
export var iconPrimary = "_1v-1g";
export var iconQuaternary = "_1v-1i";
export var iconTertiary = "_1v-1h";
export var integrationCard = "_1v-1";
export var integrationLogoBox = "_1v-2";
export var mainColumnSticky = "_1v-1b";
export var maxWidthContainer = "_1v-19";
export var modalContentBody = "_1v-a";
export var modalHeaderImage = "_1v-5";
export var modalImageLabel = "_1v-7";
export var modalImageOverlay = "_1v-6";
export var modalImageSubtitle = "_1v-9";
export var modalImageTitle = "_1v-8";
export var modalImageWrapper = "_1v-4";
export var modalStickyFooter = "_1v-b";
export var removeButton = "_1v-e";
export var sidebarColumn = "_1v-1a";
export var spinner = "_1v-i";
export var timelineLine = "_1v-y";
export var timelineLineBlack = "_1v-10 _1v-y";
export var timelineLineGray = "_1v-z _1v-y";
export var timelineLineHeight = "_1v-x";
export var tlDotActivate = "_1v-u";
export var tlDotActivateAnim = "_1v-t";
export var tlDotHide = "_1v-s";
export var tlDotHideAnim = "_1v-r";
export var tlLineActivate = "_1v-w";
export var tlLineActivateAnim = "_1v-v";
export var uploadHint = "_1v-n";
export var uploadIconBox = "_1v-k";
export var uploadLabel = "_1v-m";
export var uploadText = "_1v-l";
export var uploadZone = "_1v-f";
export var uploadZoneCursorDefault = "_1v-h";
export var uploadZoneCursorPointer = "_1v-g";
export var uploadedFileRow = "_1v-c";
export var viewButton = "_1v-d";